import { render, staticRenderFns } from "./StandeePriceThresholdModal.vue?vue&type=template&id=45c1f23a&"
import script from "./StandeePriceThresholds.ts?vue&type=script&lang=js&"
export * from "./StandeePriceThresholds.ts?vue&type=script&lang=js&"
import style0 from "./StandeePriceThresholdModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports